import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThinWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.25 21 20H3L12 4.25Z",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.25v4.6",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 17.25h.01",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		})
	]
});
export default SvgThinWarning;
